import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { tpoGenUrls } from 'config/urls';
import { tpoGenKeys } from '../../../../utils/tpoGenQueryKeys';

interface GetOptimizationIdResponse {
    optimization_id: string | null;
}

const fetchOptimizationId = async (
    planId: string,
    signal?: AbortSignal,
): Promise<string | null> => {
    const response = await axios.get<GetOptimizationIdResponse>(
        tpoGenUrls.getOptimizationId,
        { params: { plan_id: planId }, signal },
    );
    return response.data?.optimization_id ?? null;
};

const useOptimizationId = (planId: string) => {
    const { data: optimizationId = null, isLoading } = useQuery({
        queryKey: tpoGenKeys.optimizationId(planId),
        queryFn: ({ signal }) => fetchOptimizationId(planId, signal),
        enabled: !!planId,
        staleTime: 0,
        refetchOnWindowFocus: false,
    });

    return { optimizationId, isLoading };
};

export default useOptimizationId;
